import { ColorSelectControl, colorSelectOverrides, ColorSelectProps } from '@gorila-shared-ui/components';
import { Select } from 'baseui/select';
import { useEffect, useMemo, useState } from 'react';
import { VEHICLE_COLOR_OPTIONS } from '../../constants/vehicle';

const VehicleColorSelect = ({
  selectedColor,
  onChangeColor,
  required = false,
  label = 'Color',
  disabled = false,
  maxWidth,
  selectMaxWidth,
  selectOverrides,
}: ColorSelectProps) => {
  const [colorSelected, setColorSelected] = useState<string>();

  useEffect(() => {
    if (selectedColor) {
      setColorSelected(
        VEHICLE_COLOR_OPTIONS.some((color) => color.value === selectedColor) ? selectedColor : undefined
      );
    } else {
      setColorSelected(undefined);
    }
  }, [selectedColor]);

  const vehicleColorOptions = useMemo(() => {
    if (!VEHICLE_COLOR_OPTIONS) return;
    return VEHICLE_COLOR_OPTIONS.map((color) => ({ id: color.value, label: color.name }));
  }, []);

  return (
    <ColorSelectControl
      disabled={disabled}
      label={label}
      maxWidth={maxWidth}
      required={required}
    >
      <Select
        closeOnSelect
        openOnClick
        clearable={false}
        onChange={(params) => onChangeColor(params.option?.id as string | undefined)}
        options={vehicleColorOptions}
        searchable={true}
        size="compact"
        value={[{ id: colorSelected }]}
        overrides={colorSelectOverrides({
          selectedColor,
          selectMaxWidth,
          selectOverrides: selectOverrides,
        })}
      />
    </ColorSelectControl>
  );
};

export default VehicleColorSelect;
